export default __webpack_public_path__ + "static/media/PavithraBamunusinghe.c828d19b.jpg";